let k = 45;
let speed = 0.02;

export var config = {
    // 地面的高度
    groundHeight: 0.5,
    // 方块的厚度
    pathBoxThick: 0.2,
    // 路方块的长度
    pathSegmentSize: 1,
    // 路方块提前加载的数量
    pathSegmentPreloadNum: 32,
    // 金币预加载数量
    coinPreloadNum: 64,
    // 路尽头碰撞 box 预加载数量
    collideEndBoxPreloadNum: 5,

    // 路的长度
    roadLength: 8,

    // 转弯动画的帧率和速度
    turnAnimationFramerate: 6,
    turnAnimationSpeedRatio: 10,
    // 水的宽长度
    waterLen: 20,

    // 上下坡的高度
    upDownHillHeight: 0.5,

    // 人物跑步的速度, 这里用了两个 需要改
    speed: speed,
    runSpeed: 3,
    jumpSpeed: 4,
};
